<div *transloco="let t;" class="h-full relative flex ">
  <!-- <div class="absolute w-full h-full">
        <img class="w-full h-full opacity-60 object-cover " src="/assets/img/BG/bg-trainerhub.jpg" />
    </div> -->
  <!-- <div class="absolute top-0 left-0">
        <img class="w-32" src="./assets/img/Home/Label-Beta.png" />
    </div> -->
  <!-- flex-col md:flex-row -->
  <div class="background absolute! w-full h-full flex pt-6 pb-4 z-10 overflow-y-auto justify-around" [style]="'background-image: url(\''+ marketingSettings.backgroundUrl + ' \');'">
    <div *ngIf="marketingSettings.title=='default' || marketingSettings.welcomeLogoBottom" class="flex flex-col welcome-label-wrapper ">
      <!-- <div class="auth-text"> -->
      <h1 *ngIf="marketingSettings.title=='default'" class="welcome-label font-nikkyou">
        <span>{{t('signIn.welcomeTo')|uppercase}}</span>
        <br>
        <span>{{t('signIn.theKmon')|uppercase}}</span>
        <br>
        <span>{{t('signIn.trainerHub')|uppercase}}</span>
      </h1>
      <!-- </div> -->
      <div *ngIf="marketingSettings.welcomeLogoBottom" class="mt-auto genesis-logo-wrapper">
        <img class="genesis-logo" [src]="marketingSettings.welcomeLogoBottom" />
      </div>
    </div>
    <div *ngIf="marketingSettings.welcomeLogoCenter" class="flex self-center">
      <img class="max-w-full sm:max-w-128 md:max-w-140 lg:max-w-[650px]" [src]="marketingSettings.welcomeLogoCenter" />
    </div>
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    <div class="page-container w-auto justify-center md:justify-end flex">
      <router-outlet *ngIf="true"></router-outlet>
      <!-- START MAINTENANCE -->
      <!-- <div class="min-h-120 flex flex-col items-center form-card">
                <div class="w-40">
                    <img src="./assets/img/Icon/kmon-new-black.png" />
                </div>
                <span class=" text-3xl mt-10 text-center">
                    {{t('maintenance.polygon')}}
                </span>
            </div> -->
      <!-- END MAINTENANCE -->
    </div>
    <div *ngIf="marketingSettings.welcomeLogoBottom" class="mt-auto genesis-logo-wrapper-below">
      <img class="genesis-logo" [src]="marketingSettings.welcomeLogoBottom" />
    </div>
  </div>
  <!--<div class="crypto-redeem-container" *ngIf="showDotCom">
    <fa-icon [icon]="['fas', 'times']" (click)="showDotCom = false;" class="closeicon"></fa-icon>
    <div class="crypto-redeeem-banner" (click)="openCryptocom()">
      <div class="logo">
        <img src="./assets/img/Icon/cryptocom_logo.svg" />
      </div>
      <div class="content">
        <h1>Do you own a Sapphire Crypto.com NFT?</h1>
        <p>Click here to redeem your rewards, and enjoy the perks!</p>
      </div>
    </div>
  </div>-->
  <language-switch id="languageSwitchID" [direction]="switchLanguagePosition" class="fixed z-20 top-90 left-2 sm:bottom-6 sm:left-6"></language-switch>
</div>
